import { Action } from '@adgate/common/types/action.type';
import { Status } from '@adgate/common/types/status.type';
import { Component } from '@angular/core';

@Component({
  selector: 'app-action-dialog-component',
  imports: [],
  templateUrl: './action-dialog-component.html',
  styleUrl: './action-dialog-component.scss',
})
export class ActionDialogComponent 
{

}

export class ActionDialogData
{
  actionList!: Action[];
  defaultAction: Action | null;
  statusList!: Status[];
  objectType!: number;

  constructor()
  {
    this.defaultAction = Action.APPROVE;
  }
}

export class ActionDialogReturnData
{
  action!: Action;
  status!: Status | null;
}

